import React, { Component } from 'react';

import './Table.css';
import 'react-datetime/css/react-datetime.css';

import scrollToElement from 'scroll-to-element';

import infoIcon from '../imgs/info.svg';
import upIcon from '../imgs/chevron-up.svg';
import downIcon from '../imgs/chevron-down.svg';
import mapIcon from '../imgs/map-pin.svg';

import strftime from 'strftime';
import DateTime from 'react-datetime';

import { createID, markerID } from '../lib/createID';

const FORMAT_TIME_DISPLAY = '%m/%d %H:%M';
const REQ_TIME_DISPLAY = '%A %B %o, %I:%M %p';

let anHourAgo, twoWeeksAgo;

class Table extends Component {
  constructor() {
    super();
    this.state = {
      search: '',
      ddf: 'twentyfour',
      detail: undefined,
      showSubmit: false,
      openDateTime: true,
      dateError: false,
      sortProp: {
        property: 'name',
        reversed: false
      }
    }
  }

  componentDidMount() {
    twoWeeksAgo = DateTime.moment()
                    .set({
                      hour:0,
                      minute:0,
                      second:0,
                      millisecond:0
                    })
                    .subtract( 2, 'week' );
    anHourAgo = DateTime.moment().subtract( 1, 'hour' );
  }

  updateSearch(event) {
    this.setState({search: event.target.value});
  }

  toggleDDF(label,a, e) {
    a.preventDefault();
    this.setState({ddf: label});
  }

  toggleModal = () => {
    this.props.modalactivate();
  }

  submitReplay = () => {
    this.setState({showSubmit: false});
    this.props.handlereplay(this.state.newRequestTime);
  }

  updateDate = (newDate) => {
    if (newDate.isBefore( anHourAgo )) {
      this.setState({newRequestTime: newDate.toDate(), dateError: false});
    } else {
      this.setState({newRequestTime: this.props.requesttime, dateError: true});
    }
  }

  toggleDateTime = () => {
    anHourAgo = DateTime.moment().subtract( 1, 'hour' );
    twoWeeksAgo = DateTime.moment().subtract( 2, 'week' );
    this.setState({
      showSubmit: !this.state.showSubmit,
      dateError: false
    });
  }

  resetToCurrent = () => {
    this.props.handlereplay(new Date());
  }

  validRequestTime(currentDate, selectedDate) {
    return currentDate.isBefore( anHourAgo ) && currentDate.isAfter( twoWeeksAgo );
  }

  updateSort(factor) {
    let obj = {
      property: factor
    };

    if (obj.property === this.state.sortProp.property) {
      obj.reversed = !this.state.sortProp.reversed;
    } else {
      obj.reversed = false;
    }

    this.setState({sortProp: obj});
  }

  preventSubmit(event) {
    if(event.key === 'Enter'){
      event.preventDefault();
    }
  }

  showDetails(id) {
    if (id === this.state.detail) {
      return this.setState({detail: undefined});
    }
    this.setState({detail: id});
  }

  scrollTo(id) {
    let mapEl = document.querySelector('#map');
    scrollToElement(mapEl, {
      duration: 300,
      ease: 'inOutSine'
    });

    if (this.props.mode === 'radar') {
      this.props.modeswitch('gaugeRecent');
      setTimeout(function(){
        let query = document.querySelector('#' + markerID(id));
        query.classList.add('hi');

        setTimeout(function(){
          query.classList.remove('hi');
        }, 5000);
      });
      return;
    }

    let query = document.querySelector('#' + markerID(id));
    query.classList.add('hi');
    setTimeout(function(){
      query.classList.remove('hi');
    }, 5000)
  }

  render() {
    let isDDF = this.props.mode === 'gaugeDDF';
    let compareProp;
    let theader;
    let tbody;
    let footer;
    let th;
    let title;
    let controls;
    let gaugeValues = [];
    let asOf;

    if (isDDF) {
      gaugeValues = this.props.data[this.state.ddf];
      compareProp = 'displayId';
    } else {
      gaugeValues = this.props.data;
      compareProp = 'name';
    }

    if (!gaugeValues || gaugeValues.length < 1) {
      return (
        <div className="w-100 pv5 center tc">
          Loading...
        </div>
      )
    }

    let placeholder = isDDF ? gaugeValues[0].displayId : gaugeValues[0].name;

    let filteredGauges = gaugeValues.filter((gauge) => {
        let searchProp = gauge[compareProp];
        return searchProp.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1;
      }).sort((a, b) => {
        let property = this.state.sortProp.property;
        let dataProp = property !== 'name' && property !== 'id';

        if (isDDF) {
          a.name = a.displayId;
          b.name = b.displayId;
        } else {
          a.id = a.vaiId;
          b.id = b.vaiId;
        }

        if (dataProp) {
          let gaugeValueA;
          let gaugeValueB;
          if (isDDF) {
            gaugeValueA = a.durations.find((d) => {
              return d.description === property;
            });
            gaugeValueB = b.durations.find((d) => {
              return d.description === property;
            });
            a = gaugeValueA.frequencyId;
            b = gaugeValueB.frequencyId;
          } else {
            gaugeValueA = a.sums.find((d) => {
              return d.hours === property;
            });
            gaugeValueB = b.sums.find((d) => {
              return d.hours === property;
            });

            a = gaugeValueA.sum;
            b = gaugeValueB.sum;
          }
        } else {
          a = a[property];
          b = b[property];
        }

        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });

    if (this.state.sortProp.reversed) {
      filteredGauges.reverse();
    }

    if (filteredGauges.length > 0) {

      if (isDDF) {
        title = 'Recurrence Interval';
        footer = (
          <div className="table-footer">
            <p className="i ma0">A &ldquo;&lt;&rdquo; symbol indicates gauge total did not exceed minimum recurrence interval threshold.</p>
            <p className="i ma0">A &ldquo;-&rdquo; symbol indicates there is no data.</p>
          </div>
        );
        asOf = (
          <div className="ma0 table-info">
            Maximum recurrence interval for each duration in the last {this.state.ddf === 'twentyfour' ? '24' : '72'} hours as of {strftime(REQ_TIME_DISPLAY, this.props.requesttime)}.
          </div>
        );

        controls = (
          <div className="fl w-two-thirds-ns">
            <label className="f6 b db mb2">Show Last for each Duration</label>
            <label htmlFor="durationToggle24" className="accessible">Show last 24 hours for each duration.</label>
            <label htmlFor="durationToggle72" className="accessible">Show last 72 hours for each duration.</label>
            <div className="db ddf-toggle">
              <button id="durationToggle24" className={this.state.ddf === 'twentyfour' ? 'f6 link dim ba ph3 pv2 mb2 dib mr3 bg-primary white reset' : 'f6 link dim ba ph3 pv2 mb2 dib mr3 primary bg-transparent'} onClick={this.toggleDDF.bind(this, 'twentyfour')}>24 Hours</button>
              <button id="durationToggle72" className={this.state.ddf === 'seventytwo' ? 'f6 link dim ba ph3 pv2 mb2 dib mr3 bg-primary white reset' : 'f6 link dim ba ph3 pv2 mb2 dib mr3 primary bg-transparent'} onClick={this.toggleDDF.bind(this, 'seventytwo')}>72 Hours</button>
            </div>
          </div>
        );
        th = filteredGauges[0].durations.map((d, index) => {
            if ((this.state.ddf === 'twentyfour') && (index === 5)) {
              return <th key={d.description}></th> // whitespace is not allowed
            } else {
              return <th className="fw6 bb b--black-20 tl pb2 pr3 bg-white" key={d.description} onClick={this.updateSort.bind(this, d.description)}>{d.description}</th>
            }
        });

        let accordionSpace = (<th className="fw6 bb b--black-20 tl pb2 bg-white" key="accordion-button"></th>);
        th.push(accordionSpace);

        tbody = [];
        filteredGauges.forEach((d, i) => {

          let data = [];
          let detailData = [];

          d.durations.forEach((s, i) => {
            if (this.state.ddf === 'twentyfour' && i === 5) return;
            let widthClass = this.state.ddf === 'twentyfour' ? 'w-20 w-auto-ns' : 'w-15';

            s.categories.push({
              frequencyId: null,
              description: '-',
              depth: null
            });
            let freq = s.categories.find((f) => {
              return f.frequencyId === s.frequencyId;
            });

            let classes = 'pv1 pr1 pr3-ns bb b--black-20 dib dtc-ns ' + widthClass;

            let recInt = freq.description === '<2 mo.' ? '<' : freq.description; // requested by client
            let topData = (
              <td className={classes} key={d.displayId + s.description}><span className="mini-font pb1">{s.description}</span>{recInt}</td>
            );

            data.push(topData);

            if (this.state.detail === d.id) {
              let bottomData = (
                <td className="pv1 pr3 bb b--black-20 ri-details" key={d.displayId + s.description + 'detail'}>
                  <p>{strftime(FORMAT_TIME_DISPLAY, new Date(s.startOfRainfall))}</p>
                  <p>{strftime(FORMAT_TIME_DISPLAY, new Date(s.endOfRainfall))}</p>
                  <p>{s.rainfall} inch{+s.rainfall > 1 ? 'es' : ''}</p>
                </td>
              );
              detailData.push(bottomData);
            }
          });

          let alt = "Map Icon " + d.displayId;

          let topRow = (
            <tr key={d.displayId} className="db dt-row-ns" id={createID(d.id)}>
              <td className="pv1 pr3-ns bb-ns b--black-20 b fw4-ns f5 db dtc-ns">
                <button title={"Locate " + d.displayId + " on map"} className="input-reset bg-transparent reset map-icon" onClick={this.scrollTo.bind(this, d.id)}>
                  <img src={mapIcon} alt={alt}/>
                </button>
                {d.displayId}
              </td>
              <td className="pv1 pr3 bb b--black-20 dn dtc-ns">{d.id}</td>
              {data}
              <td className="pv1 bb b--black-20 dn dtc-ns">
                <button onClick={this.showDetails.bind(this, d.id)} className="input-reset bg-transparent reset pa0 accordion">
                  <img src={this.state.detail === d.id ? upIcon : downIcon} alt={'Toggle detail for' + d.displayId}/>
                </button>
              </td>
            </tr>
          );
          tbody.push(topRow);

          if (this.state.detail === d.id) {
            let bottomRow = (
              <tr key={d.displayId + 'detail'} className="dn dt-row-ns">
                <td className="pv1 pr3 bb b--black-20 mw5"></td>
                <td className="pv1 pr3 bb b--black-20">
                  <div className="tr dib fl b ri-details">
                    <p>From:</p>
                    <p>To:</p>
                    <p>Rainfall:</p>
                  </div>
                </td>
                {detailData}
                <td className="pv1 bb b--black-20"></td>
              </tr>
            );
            tbody.push(bottomRow);
          }

        });

      } else {
        title = 'Recent Rainfall';
        footer = (
          <div className="table-footer">
            <p className="i ma0">A &ldquo;-&rdquo; symbol indicates there is no data.</p>
          </div>
        );

        asOf = (
          <div className="ma0">
            Rainfall totals as of {strftime(REQ_TIME_DISPLAY, this.props.requesttime)}.
          </div>
        );

        th = filteredGauges[0].sums.map((d) => {
          return (
            <th className="fw6 bb b--black-20 tl pb2 pr3 bg-white" key={d.hours} onClick={this.updateSort.bind(this, d.hours)}>{d.hours} Hour{d.hours > 1 ? 's' : ''}</th>
          );
        });
        tbody = filteredGauges.map((d) => {
          let data = d.sums.map((s) => {
            return (
              <td className="pv1 pr3 bb b--black-20 dib dtc-ns w-20 w-auto-ns" key={d.name + s.hours}>
                <span className="mini-font pb1">{s.hours} hr</span>
                {typeof s.sum === 'number' ? s.sum : '-'}
              </td>
            );
          });

          let alt = 'Map Icon ' + d.name;
          return (
            <tr key={d.name} className="db dt-row-ns" id={createID(d.vaiId)}>
              <td className="pv1 pr3-ns bb-ns b--black-20 b fw4-ns f5 db dtc-ns">
                <button title={"Locate " + d.name + " on map"} className="input-reset bg-transparent reset map-icon" onClick={this.scrollTo.bind(this, d.vaiId)}>
                  <img src={mapIcon} alt={alt}/>
                </button>
                {d.name}
              </td>
              <td className="pv1 pr3 bb b--black-20 dn dtc-ns">{d.vaiId}</td>
              {data}
            </tr>
          );
        });
      }

      theader = (
        <tr>
          <th className="fw6 bb b--black-20 tl pb2 pr3 mw5 bg-white dn dtc-ns" onClick={this.updateSort.bind(this, 'name')}>Gauge Name</th>
          <th className="fw6 bb b--black-20 tl pb2 pr3 bg-white dn dtc-ns" onClick={this.updateSort.bind(this, 'id')}>ID</th>
          {th}
        </tr>
      );

    } else {
      tbody = (
        <tr>
          <td>There are no gauges matching your parameters.</td>
        </tr>
      );
    }

    return (
      <section className="w-100 mw8 ph2 pv4 center black">
        <div className="cf relative table-info">
          <h2 className="ma0 f3">{title}</h2>
          <button className="input-reset bg-transparent reset icon" onClick={this.toggleModal}>
            <img src={infoIcon} alt="Information Icon"/>
          </button>
          {asOf}
          {this.state.dateError ? <p className="error">Choose a time within the last 2 weeks before {strftime(REQ_TIME_DISPLAY, anHourAgo.toDate())}.</p> : <span></span>}
          {
            this.state.showSubmit ?
            (<div className="time-picker">
              <button onClick={this.toggleDateTime}>Cancel</button><button onClick={this.submitReplay} disabled={this.state.dateError}>Submit</button>
              <DateTime defaultValue={(this.props.isreplay ? this.props.requesttime : anHourAgo)} onChange={this.updateDate} isValidDate={this.validRequestTime} open={this.openDateTime} input={false} disableOnClickOutside={false} className="timeControl" />
            </div>) :
            (
              <div className="time-picker">
                <button onClick={this.resetToCurrent} disabled={!this.props.isreplay}>Reset to Current</button>
                <button onClick={this.toggleDateTime}>Change Date</button>
                <span>Choose a time within the last 2 weeks before {strftime(REQ_TIME_DISPLAY, anHourAgo.toDate())}.</span>
              </div>
            )
          }
          <form className="black-80 pt4 cf">
            <div className="fl w-100 w-third-ns pr3-ns">
              <label htmlFor="filter" className="f6 b db mb2">Search by Gauge Name</label>
              <input value={this.state.search} onChange={this.updateSearch.bind(this)} id="filter" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" placeholder={placeholder} onKeyPress={this.preventSubmit}/>
            </div>
            {controls}
          </form>
        </div>
        <div className="overflow-auto pt2">
          <table className="f6 w-100" cellSpacing="0">
            <thead className="dn dt-row-group-ns">
              {theader}
            </thead>
            <tbody className="lh-copy db dt-row-group-ns">
              {tbody}
            </tbody>
          </table>
          {footer}
        </div>
      </section>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table.js